import { type Message, Messages, TransportManager } from '@atlas/transport';
import { useEffect } from 'react';

TransportManager.getInstance();

const useClientUpdates = (
  callback: (message: Message) => void,
  token?: string,
) => {
  const transport = TransportManager.getInstance();

  useEffect(() => {
    if (token) {
      transport.setToken(`Bearer ${token}`);

      return transport.subscribe(Messages.authorizedClientUpdates(), callback);
    }
  }, [token, transport, callback]);
};

export default useClientUpdates;
